import React from "react";
import { Progress } from "reactstrap";
import "./animatedProgressBar.css";

// This component will animate the width of the progress bar programmatically
// using a CSS animation. When the animation completes, we add change the 'animated'
// prop on <Progress /> which gives us the bootstrap animated progress bar.

export default class AnimatedProgressBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      animated: false
    };
    this.displayName = "AnimatedProgressBar";
    this.progressBar = null;
    this.handleAnimationEnd = this.handleAnimationEnd.bind(this);
  }

  handleAnimationEnd(event) {
    this.setState({
      animated: true
    });
  }

  componentDidMount() {
    this.progressBar.addEventListener("animationend", this.handleAnimationEnd);
  }

  componentWillUnmount() {
    this.progressBar.removeEventListener(
      "animationend",
      this.handleAnimationEnd
    );
  }

  render() {
    const { animated } = this.state;
    // Attaching a ref to the container div, because reactstrap's Progress
    // won't allow us to attach a ref there
    return (
      <div
        ref={barContainer => {
          this.progressBar = barContainer;
        }}
      >
        <Progress animated={animated} bar value={100} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Shared/AnimatedProgressBar.js